var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Quote component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconQuote extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5906 2.60516H3.41526C3.20023 2.60516 2.99401 2.69058 2.84196 2.84263C2.68991 2.99468 2.60449 3.2009 2.60449 3.41593V20.5844C2.60449 20.7994 2.68991 21.0056 2.84196 21.1577C2.99401 21.3097 3.20023 21.3952 3.41526 21.3952H20.5837C20.7988 21.3952 21.005 21.3097 21.157 21.1577C21.3091 21.0056 21.3945 20.7994 21.3945 20.5844V10.409H15.121C14.7151 10.409 14.3258 10.2478 14.0388 9.96079C13.7518 9.67379 13.5906 9.28453 13.5906 8.87865V2.60516ZM14.3405 1.10516H14.3406C14.5396 1.10516 14.7303 1.18418 14.871 1.32483L22.6748 9.12868C22.8155 9.26933 22.8945 9.4601 22.8945 9.65901V20.5844C22.8945 21.1973 22.651 21.785 22.2177 22.2184C21.7843 22.6517 21.1966 22.8952 20.5837 22.8952H3.41526C2.80241 22.8952 2.21465 22.6517 1.7813 22.2184C1.34795 21.785 1.10449 21.1973 1.10449 20.5844V3.41593C1.10449 2.80308 1.34795 2.21533 1.7813 1.78197C2.21465 1.34862 2.80241 1.10516 3.41526 1.10516H14.3404C14.3404 1.10516 14.3404 1.10516 14.3405 1.10516ZM15.0906 8.87865V3.66585L20.3338 8.90903H15.121C15.1129 8.90903 15.1052 8.90583 15.0995 8.90013C15.0938 8.89443 15.0906 8.88671 15.0906 8.87865Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.09717 5.00702C8.51138 5.00702 8.84717 5.34281 8.84717 5.75702V7.40757C9.32597 7.48553 9.77634 7.64162 10.1558 7.88297C10.7446 8.2574 11.1882 8.86363 11.1882 9.6591C11.1882 10.0733 10.8524 10.4091 10.4382 10.4091C10.024 10.4091 9.68817 10.0733 9.68817 9.6591C9.68817 9.48689 9.60884 9.31273 9.35091 9.1487C9.07751 8.97483 8.64196 8.84833 8.09701 8.84833C7.76509 8.84833 7.49124 8.84887 7.24972 8.86989C7.0075 8.89097 6.85333 8.92906 6.75454 8.97458C6.6732 9.01206 6.6323 9.05214 6.59973 9.11257C6.55909 9.18799 6.50586 9.34655 6.50586 9.6591C6.50586 9.94804 6.63347 10.1945 6.96761 10.473C7.32645 10.772 7.82589 11.0262 8.43242 11.3294L8.47355 11.35C9.02885 11.6275 9.68016 11.9531 10.1867 12.3752C10.7305 12.8283 11.1882 13.4598 11.1882 14.3414C11.1882 14.8092 11.1107 15.236 10.9148 15.5995C10.7108 15.9781 10.4093 16.2306 10.0673 16.3882C9.7427 16.5378 9.39255 16.5973 9.07436 16.625C8.99972 16.6315 8.92377 16.6364 8.84717 16.6402V18.2432C8.84717 18.6574 8.51138 18.9932 8.09717 18.9932C7.68295 18.9932 7.34717 18.6574 7.34717 18.2432V16.608C6.89183 16.5505 6.44774 16.4304 6.06629 16.2106C5.41794 15.8372 5.00586 15.2034 5.00586 14.3414C5.00586 13.9272 5.34165 13.5914 5.75586 13.5914C6.17007 13.5914 6.50586 13.9272 6.50586 14.3414C6.50586 14.65 6.61664 14.7966 6.81501 14.9109C7.06943 15.0574 7.49506 15.1508 8.08364 15.1522C8.08814 15.1521 8.09265 15.152 8.09717 15.152C8.10197 15.152 8.10676 15.1521 8.11154 15.1522C8.43695 15.1522 8.70631 15.1513 8.9443 15.1306C9.18653 15.1095 9.3407 15.0714 9.43948 15.0259C9.52082 14.9884 9.56173 14.9484 9.5943 14.8879C9.63494 14.8125 9.68817 14.654 9.68817 14.3414C9.68817 14.0525 9.56056 13.806 9.22642 13.5275C8.86758 13.2285 8.36814 12.9743 7.7616 12.6711L7.72048 12.6505C7.16517 12.373 6.51387 12.0474 6.00733 11.6253C5.46354 11.1722 5.00586 10.5407 5.00586 9.6591C5.00586 9.19126 5.08335 8.76453 5.27926 8.40098C5.48325 8.02245 5.78473 7.76988 6.12675 7.61227C6.45133 7.4627 6.80148 7.40323 7.11967 7.37554C7.19441 7.36903 7.27046 7.36408 7.34717 7.36032V5.75702C7.34717 5.34281 7.68295 5.00702 8.09717 5.00702Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5908 15.9021C13.5908 15.4879 13.9266 15.1521 14.3408 15.1521H19.0231C19.4373 15.1521 19.7731 15.4879 19.7731 15.9021C19.7731 16.3163 19.4373 16.6521 19.0231 16.6521H14.3408C13.9266 16.6521 13.5908 16.3163 13.5908 15.9021Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconQuote.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconQuote.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconQuote.prototype, "size", void 0);
if (customElements.get('cat-icon-quote') === undefined) {
    customElements.define('cat-icon-quote', BlocksIconQuote);
}
